import { Component } from '@angular/core';

@Component({
    selector: 'app-link-with-arrow',
    templateUrl: './link-with-arrow.component.html',
    standalone: false
})
export class LinkWithArrowComponent {}
